import { useHoverIntent } from 'react-use-hoverintent';
import * as React from 'react';
import DesktopDropdown from '../DesktopDropdown/DesktopDropdown';
import S from '../DesktopNavigation/DesktopNavigation.styles';
const DesktopNavigation = ({ item, onClick }) => {
    const [active, setActive] = React.useState(false);
    const [hovered, anchorRef] = useHoverIntent({
        // These settings ensure the drop down doesn't appear until the user stops moving the mouse for 100ms
        interval: 100,
        sensitivity: 100,
        // This allows 250ms before hiding the drop down if the mouse leaves the item or drop down
        timeout: 250,
    });
    return (React.createElement(S.Item, { ref: anchorRef, "data-d-active": active || hovered },
        React.createElement(S.Link, { href: item.url, target: item.target, onKeyDown: (event) => {
                switch (event.key) {
                    case 'ArrowDown':
                    case 'Escape':
                        setActive(true);
                        break;
                    case 'ArrowUp':
                        setActive(false);
                        break;
                    default:
                        break;
                }
            }, onClick: onClick }, item.text),
        !!item.children?.length && (React.createElement(DesktopDropdown, { articles: item.articles, isActive: active || hovered, items: item.children, title: item.text }))));
};
export default DesktopNavigation;
